exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-radio-icon[data-v-71957093]{display:flex;flex-wrap:wrap}.setting-radio-icon li[data-v-71957093]{margin-right:10px}.setting-radio-icon input[type=radio][data-v-71957093]{display:none}.setting-radio-icon input[type=radio]:checked~label[data-v-71957093]{background-color:#5b86e5;color:#fff;transform:scale(1.02);box-shadow:0 3px 8px 2px #ccc}.setting-radio-icon label[data-v-71957093]{background-color:#eee;transition:all .3s ease;display:block;padding:12px;border-radius:50%;color:#444}.setting-radio-icon label i[data-v-71957093]{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71957093","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/fields/radio-icon.vue
// module id = 73
// module chunks = 0